__webpack_require__.p = "/auto-install/assets/";